import { render, staticRenderFns } from "./LazyPicture.vue?vue&type=template&id=2bd98bbe&scoped=true"
import script from "./LazyPicture.vue?vue&type=script&setup=true&lang=js"
export * from "./LazyPicture.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LazyPicture.vue?vue&type=style&index=0&id=2bd98bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd98bbe",
  null
  
)

export default component.exports